import { Injectable } from '@angular/core';
import {DxRequestOptions} from "../../dx-core/domain/http/dx-request-options";
import {HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {BdpkConfigService} from "../../bdpk-common/services/bdpk-config.service";
import {DxObjectMapper} from "../../dx-core/services/dx-object-mapper.service";
import {DxHttpDispatcher} from "../../dx-core/services/dx-http-dispatcher.service";
import {Observable} from "rxjs";
import {PitAgreementTask} from "../../pit-agreement/domain/pit-agreement-task";
import {map, take} from "rxjs/operators";
import {PitUser} from "../domain/pit-user";
import {PitResponsibleUser} from "../domain/pit-responsible-user";

/**
 *  Service corresponding with responsibles-service server endpoint
 */
@Injectable({
  providedIn: 'root'
})
export class PitResponsiblesService {

  private rsContext: string;
  private rsOptions: DxRequestOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8'),
    observe: "response",
    withCredentials: true
  };

  constructor (private _configService: BdpkConfigService,
               private _mapper: DxObjectMapper,
               private _http: DxHttpDispatcher) {
    this.rsContext = this._configService.pitBackendResponsiblesEndPoint;
  }

  create(objectId: number, objectTypeId: number): Observable<{objectId: number, objectTypeId: number, responsibleUsers: PitResponsibleUser[]}> {
    return this._http.post(`${this.rsContext}/object/${objectId}/type/${objectTypeId}`, null, this.rsOptions)
      .pipe(take(1),
            map((response: HttpResponse<any>) => {
              response.body.responsibleUsers = this._mapper.deserializeASArray(response.body.responsibleUsers, PitResponsibleUser);
              return response.body as any;
            }));
  }

  getAll(objectId: number, objectTypeId: number): Observable<{objectId: number, objectTypeId: number, responsibleUsers: PitResponsibleUser[]}> {
    return this._http.get(`${this.rsContext}/object/${objectId}/type/${objectTypeId}`, this.rsOptions)
                     .pipe(take(1),
                           map((response: HttpResponse<any>) => {
                                if (response.body)
                                    response.body.responsibleUsers = this._mapper.deserializeASArray(response.body.responsibleUsers, PitResponsibleUser);
                                return response.body as any;
    }));
  }

  updateEntry(objectId: number, objectTypeId: number, respUser: PitResponsibleUser): Observable<{objectId: number, objectTypeId: number, responsibleUsers: PitResponsibleUser[]}> {
    const body = this._mapper.serialize(respUser, PitResponsibleUser);
    return this._http.put(`${this.rsContext}/object/${objectId}/type/${objectTypeId}/resuser/${respUser.id}`, body, this.rsOptions)
      .pipe(take(1),
        map((response: HttpResponse<any>) => {
          response.body.responsibleUsers = this._mapper.deserializeASArray(response.body.responsibleUsers, PitResponsibleUser);
          return response.body as any;
        }));
  }
}
